module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "width": "16",
      "height": "14",
      "viewBox": "0 0 16 14",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M14.5724 0.609375H1.42602C0.98852 0.609375 0.715306 1.08616 0.934948 1.46652L5.08852 8.52723V12.8237C5.08852 13.1397 5.34209 13.3951 5.65638 13.3951H10.3421C10.6564 13.3951 10.9099 13.1397 10.9099 12.8237V8.52723L15.0653 1.46652C15.2832 1.08616 15.0099 0.609375 14.5724 0.609375ZM9.63138 12.1094H6.36709V9.32366H9.63316V12.1094H9.63138ZM9.8028 7.88438L9.63316 8.1808H6.36531L6.19566 7.88438L2.65459 1.89509H13.3439L9.8028 7.88438Z",
      "fill": "#004A98"
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8ae094ca", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ae094ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/FilterActiveIcon.vue
// module id = 1511
// module chunks = 159